import React, { Fragment } from 'react';
import { useRouter } from 'next/router';
import ReactHtmlParser from 'react-html-parser';

import HelpDeskContent from '../HelpDeskContent';
import HelpDeskLateral from '../Lateral';
import FooterSimple from '../../FooterSimple';
import UsefulQuestion from '../../UsefulQuestion';

import routes from '../../../utils/routes';
import { stringToTemplate } from '../../../utils/parser';

type HelpDeskQuestionT = {
  categories: HelpDeskCategory[];
  category: HelpDeskCategory;
  question: HelpDeskQuestion;
};

const HelpDeskQuestion = ({ categories, category, question }: HelpDeskQuestionT) => {
  const router = useRouter();

  const breadcrumbPages = [
    {
      label: category.categoryDescription,
      url: `${routes.helpDesk}/${category.categoryKeyword}`,
    },
    {
      label: question.title,
      url: '',
    },
  ];

  const questions = category.questions.map((question: HelpDeskQuestion) => ({
    id: question.id,
    title: question.title,
    onClick: () => router.push(`${routes.helpDesk}/${router.query.category}/${question.keyword}`),
  }));

  return (
    <Fragment>
      <HelpDeskContent
        categories={categories}
        breadcrumbPages={breadcrumbPages}
        title={question.title}
        lateral={
          <HelpDeskLateral
            title={category.categoryDescription}
            selectedId={question.id}
            options={questions}
          />
        }
        content={
          <Fragment>
            {ReactHtmlParser(stringToTemplate(question.content))}
            <UsefulQuestion
              question={{
                questionId: question.id,
                questionTitle: question.title,
                categoryId: category._id,
              }}
            />
          </Fragment>
        }
      />

      <FooterSimple />
    </Fragment>
  );
};

export default HelpDeskQuestion;
